import { reactQueryPost } from "@circle-react/helpers/backendRequestHelpers";
import { internalApi } from "@circle-react/helpers/urlHelpers";
import type {
  MasqueradingEntityType,
  MasqueradingMode,
} from "@circle-react/types/Masquerading";

import { setCircleAiMasqueradingSession } from "@/react/helpers/circleAiMasqueradingSession";

export const viewOnlyMasqueradeAs = ({
  entityId,
  entityType = "CommunityMember",
  mode = "view",
}: {
  entityId: string | number;
  entityType: MasqueradingEntityType;
  mode?: MasqueradingMode;
}) =>
  reactQueryPost<{ masquerade_url: string }>(
    internalApi.masquerading.masquerades.create({
      entityId,
      entityType,
      mode,
    }),
    {
      method: "POST",
    },
  ).then(data => {
    // Every successful member/mode switch starts with Circle AI opted out,
    // including switching back to the same member.
    setCircleAiMasqueradingSession(null);
    return data;
  });
